import { render } from "./Home.vue?vue&type=template&id=6467605e&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6467605e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6467605e"

export default script